import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const ContractPage = () => {
  const { id } = useParams();
  const decodedId = atob(id);
  const [contract, setContract] = useState(null);
  const [title, setTitle] = useState("");
  const [signature, setSignature] = useState("");
  const [agree, setAgree] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

 /* useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}get_contract.php?rid=${rid}`)
      .then((res) => {
        if (res.data.success) {
          setContract(res.data.contract);

          if (res.data.contract.bwc_signature) {
            const [savedTitle, savedName] =
              res.data.contract.bwc_signature.split("~");
            setTitle(savedTitle);
            setSignature(savedName);
          }
        }
      })
      .finally(() => setLoading(false));
  }, [rid]); */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agree) {
      alert("You must agree to the terms.");
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/submit_contract.php`,
        {
          coordinator_id: decodedId,
          title,
          signature,
          agree: agree ? 1 : 0,
        }
      );

      if (res.data.success) {
        alert("Contract submitted successfully!");
        navigate(`/general-login`);
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      alert("Error submitting contract.");
    }
  };


  const handlePrint = () => {
    window.print();
  };

  const handleEmail = async () => {
    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}email_contract.php`,
      { decodedId }
    );
    alert("Contract emailed successfully!");
  };

 // if (loading) return <div className="text-center mt-5">Loading...</div>;
 // if (!contract) return <div className="text-center mt-5">Invalid Contract</div>;

  return (
    <div className="container mt-5 mb-5">
      <div className="text-center mb-4">
        <h2>Authormeet Confirmation & Contract</h2>
      </div>

      <div className="row mb-4">
        <div className="col-md-6 text-center">
          <h4>{contract?.bwc_orgname}</h4>
          <p>
            {contract?.bwc_startdate} to {contract?.bwc_enddate}{" "}
            {contract?.bwc_year}
          </p>
          <strong>Authormeet Dates</strong>
        </div>

        <div className="col-md-6 text-center">
          <h4>Virtual/Online Bookstore</h4>
          <p>{contract?.bwc_year}</p>
          <strong>School Year</strong>
        </div>
      </div>

      <p>
        We wish to thank you for selecting Bookworm Central as your authormeet
        company. We work with a wide range of publishers and review hundreds of
        books to create a list that is varied and exciting.
      </p>

      <p>
        <strong>
          You may choose to receive your proceeds in cash, books, or a
          combination of the two.
        </strong>
      </p>

      <p><strong>You will receive:</strong></p>
      <ul>
        <li>25% cash / 35% books (over $8,000)</li>
        <li>20% cash / 30% books ($4,000 - $8,000)</li>
        <li>15% cash / 25% books (under $4,000)</li>
      </ul>

      <form onSubmit={handleSubmit}>
        <div className="row mt-4">
          {/* Coordinator Section */}
          <div className="col-md-6">
            <div className="form-check mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
                required
              />
              <label className="form-check-label">
                I agree to the above proceeds and terms and conditions
              </label>
            </div>

            <div className="row">
              <div className="col-md-4">
                <label>Title</label>
                <select
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                >
                  <option value="">Select</option>
                  <option value="Dr">Dr</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Miss">Miss</option>
                </select>
              </div>

              <div className="col-md-8">
                <label>Signature (Full Name)</label>
                <input
                  type="text"
                  className="form-control"
                  value={signature}
                  onChange={(e) => setSignature(e.target.value)}
                  required
                />

                <div
                  style={{
                    fontFamily: "'Cedarville Cursive', cursive",
                    fontSize: "32px",
                    marginTop: "10px",
                    transform: "skewY(-5deg)",
                  }}
                >
                  {signature}
                </div>
              </div>
            </div>
          </div>

          {/* Bookworm Central Section */}
          <div className="col-md-6 text-center">
            <h5>Bookworm Central</h5>

            <div className="row mt-3">
              <div className="col-md-4">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  value="Mrs"
                  readOnly
                />
              </div>

              <div className="col-md-8">
                <label>Signature (Full Name)</label>
                <input
                  type="text"
                  className="form-control"
                  value="Laurie Rothenberg"
                  readOnly
                />
                <div
                  style={{
                    fontFamily: "'Cedarville Cursive', cursive",
                    fontSize: "32px",
                    marginTop: "10px",
                  }}
                >
                  Laurie Rothenberg
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="text-center mt-5">
          <button
            type="button"
            onClick={handlePrint}
            className="btn btn-secondary me-3"
          >
            Print
          </button>

          {/*<button
            type="button"
            onClick={handleEmail}
            className="btn btn-secondary me-3"
          >
            Email
          </button> */}

          <button type="submit" className="btn btn-dark">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContractPage;
